<template>
  <div class="qr-receipt-process">
    <vs-chip :color="state.status === 'COMPLETED' ? 'success' : ['REVIEW', 'CANCELLED'].includes(state.status) ? 'danger' : 'warning'">{{ statusText }}</vs-chip>
    <span v-if="state.message" class="selectable" role="status">{{ state.message }}</span>
    <vs-button v-if="qr && state.status === 'RECEIVED'" size="small" :disabled="busy || mustRefresh" @click="confirm = true">ประมวลผลค่าใช้จ่าย</vs-button>
    <vs-button v-if="mustRefresh" size="small" :disabled="busy" @click="refresh">รีเฟรชตรวจสอบสถานะ</vs-button>
    <vs-popup :active.sync="confirm" title="ตรวจสอบก่อนประมวลผล QR">
      <p>ประมวลผลค่าใช้จ่ายรายการนี้เท่านั้น ไม่ประมวลผล Payment และไม่ปิดบัญชีอัตโนมัติ กรุณาตรวจสอบการรับเงินก่อนยืนยัน</p>
      <vs-button :disabled="busy" @click="process">ยืนยันประมวลผล</vs-button>
      <vs-button :disabled="busy" @click="confirm = false">ยกเลิก</vs-button>
    </vs-popup>
    <vs-popup :active="!!message" title="สถานะการประมวลผล" :button-close-hidden="true">
      <p class="selectable">{{ message }}</p>
      <vs-button @click="message = ''">ตกลง</vs-button>
    </vs-popup>
  </div>
</template>
<script>
import { gql } from 'apollo-boost'
import { apolloClient } from '@/setup/apollo-setup'
const PROCESS = gql`mutation ProcessQrPaymentExpense($qrPaymentId: ID!, $paymentExpenseId: ID!, $contractId: ID!) {
  processQrPaymentExpense(qrPaymentId: $qrPaymentId, paymentExpenseId: $paymentExpenseId, contractId: $contractId)
}`
const STATUS = gql`query QrExpenseStatus($id: ID!) { getQrPayment(id: $id) { id expenseSettlement { status message } } }`
export default {
  props: { qr: { type: Object, default: null }, paymentExpenseId: { type: String, required: true }, approvedStatus: { type: String, default: '' } },
  data: () => ({ busy: false, confirm: false, mustRefresh: false, message: '' }),
  computed: {
    state () {
      if (this.approvedStatus === 'Cancel') return { status: 'CANCELLED', message: '' }
      return (this.qr && this.qr.expenseSettlement) || { status: 'REVIEW', message: 'ไม่พบข้อมูล QR ที่เชื่อมกับค่าใช้จ่าย กรุณาตรวจสอบรายการ' }
    },
    statusText () {
      if (this.busy) return 'กำลังประมวลผล'
      return ({ RECEIVED: 'รอประมวลผล', PROCESSING: 'กำลังประมวลผล', COMPLETED: 'ประมวลผลแล้ว', REVIEW: 'ต้องตรวจสอบรายการ', NOT_RECEIVED: 'ยังไม่ยืนยันรับเงิน', CANCELLED: 'ยกเลิก' })[this.state.status] || 'กรุณาตรวจสอบรายการ QR'
    }
  },
  methods: {
    async refresh () {
      this.busy = true
      try {
        const { data } = await apolloClient.query({ query: STATUS, variables: { id: this.qr.id }, fetchPolicy: 'network-only' })
        await this.$store.dispatch('Accounting/getContractDetail', { id: this.$route.params.id })
        this.mustRefresh = !data || !data.getQrPayment || !data.getQrPayment.expenseSettlement || data.getQrPayment.expenseSettlement.status !== this.state.status
      } catch (_) { this.message = 'ตรวจสอบสถานะไม่สำเร็จ กรุณารอแล้วรีเฟรชอีกครั้ง'; this.mustRefresh = true }
      finally { this.busy = false }
    },
    async process () {
      if (this.busy || this.mustRefresh || !this.qr || !this.paymentExpenseId || this.state.status !== 'RECEIVED') return
      this.busy = true
      this.confirm = false
      try {
        await apolloClient.mutate({ mutation: PROCESS, variables: { qrPaymentId: this.qr.id, paymentExpenseId: this.paymentExpenseId, contractId: this.$route.params.id } })
        await this.$store.dispatch('Accounting/getContractDetail', { id: this.$route.params.id })
      } catch (error) {
        this.mustRefresh = true
        const reviewed = (error.graphQLErrors || []).find(item => item.extensions && item.extensions.code === 'qr_expense_processing_failed')
        this.message = (reviewed ? reviewed.message + ' ' : '') + 'กรุณารีเฟรชตรวจสอบสถานะก่อนดำเนินการต่อ ระบบจะไม่เรียกประมวลผลซ้ำอัตโนมัติ'
      } finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.qr-receipt-process { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; }
.selectable { user-select: text; line-height: 1.8; }
</style>
